import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Servizio centralizzato per la gestione dei documenti e export
 */
@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  private http = inject(HttpClient);

  /**
   * Export generico per Excel
   * @param endpoint - L'endpoint specifico per il tipo di export (es. SUP_REF_01, RESP_REF_01, SUB_RESP_REF_01, MFA_01)
   * @param supplierId - ID del fornitore (opzionale)
   * @param responsibleId - ID del responsabile (opzionale)
   * @param subResponsibleId - ID del sub-responsabile (opzionale)
   * @param professionalId - ID del fiduciario, richiesto dal modello MFA_01 (opzionale)
   * @returns Observable con la risposta HTTP contenente il Blob del file Excel
   */
  exportRegistry(
    endpoint: string,
    supplierId?: number | null,
    responsibleId?: number | null,
    subResponsibleId?: number | null,
    professionalId?: string | number | null
  ): Observable<HttpResponse<Blob>> {
    const params: any = {};

    if (supplierId) params.supplierId = supplierId.toString();
    if (responsibleId) params.responsibleId = responsibleId.toString();
    if (subResponsibleId) params.subResponsibleId = subResponsibleId.toString();
    if (professionalId) params.professionalId = professionalId.toString();

    const url = `${environment.backofficeApiUrl}/api/v1/excel/${endpoint}`;
    
    return this.http.get(url, {
      params: Object.keys(params).length > 0 ? params : undefined,
      responseType: 'blob',
      observe: 'response',
    });
  }
}
